import { useParams, useSearchParams } from "react-router-dom"
import { Home } from "./Home"

export const TagProducts = () => {
  const { id } = useParams<{ id: string }>()
  const [searchParams] = useSearchParams()
  const tagId = id ? Number(id) : undefined
  const categoryId = Number(searchParams.get("category_id")) || undefined

  return (
    <Home
      key={`${tagId}-${categoryId}`}
      tagId={tagId}
      initialCategoryId={categoryId}
      showHero={false}
    />
  )
}
